/**
 * GovernanceDashboardPage - Governance primitive dashboard
 *
 * Surfaces the GovernanceDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides centralized view of 5 governance primitives: Escalation, Schedule, Resource, Integration, Policy.
 *
 * Route: /admin/governance-dashboard
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconScale } from '@tabler/icons-react';

import { GovernanceDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function GovernanceDashboardPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="yellow">
            <IconScale size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Governance Dashboard</Title>
            <Text size="sm" c="dimmed">
              Centralized governance: Escalation, Schedule, Resource, Integration, Policy
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <GovernanceDashboard />
    </Container>
  );
}

export default GovernanceDashboardPage;
